import React from 'react';
import { BsChatRightTextFill } from 'react-icons/bs';
import StarRating from '../../../components/UI/StarRating';
import styles from '../FeedbackPage.module.css';

const QuestionSection1 = ({ q1Rating, handleRatingChange, isLoading, moveToNextSection, activeSection }) => (
  <div id="section-1" className={`${styles.questionSection} ${activeSection === 1 ? styles.active : ''}`}>
    <div className={styles.questionIcon}><BsChatRightTextFill /></div>
    <label className={styles.questionLabel}>
      1. How would you rate the product description generated? <span className={styles.required}>*</span>
    </label>
    <div className={styles.ratingContainer}>
      <StarRating
        rating={q1Rating}
        onRate={(rate) => handleRatingChange(1, rate)}
        disabled={isLoading}
        size={32}
      />
      {q1Rating > 0 && (
        <div className={styles.ratingText}>
          {['Poor', 'Fair', 'Good', 'Very Good', 'Excellent'][q1Rating - 1]}
        </div>
      )}
    </div>
    <div className={styles.navigationButtons} style={{ justifyContent: 'center' }}>
      <button
        type="button"
        className={`${styles.btn} ${styles.btnPrimary}`}
        disabled={q1Rating === 0}
        onClick={moveToNextSection}
      >
        Next
      </button>
    </div>
  </div>
);

export default QuestionSection1;
